import React from 'react';

import {HashRouter as Router,Route,Link} from 'react-router-dom';
import AddShop from './Shop/AddShop';
import ShopList from './Shop/ShopList';

class Shop extends React.Component{


  constructor(props){
   super(props)
   this.state={
       name:""
   }
  }


  render(){

    return(
        <Router>
        <div className="shop">
        <div className="content">

        <div className="left">
           <Link to={`/shop/addShop`}>添加商品</Link>
           <br/>
           <br/>
           <Link to={`/shop/shopList`}>商品列表</Link>
        </div>

        <div className="right">
         <Route path={`/shop/addShop`} component={AddShop}/>
         <Route path={`/shop/shopList`} component={ShopList}/>            
        </div>

        </div>
        
        </div>
        </Router>
    );
  }
}

export default Shop;


// WEBPACK FOOTER //
// ./src/components/Shop.js